import httpClient from '../../../utils/httpClient';

const resource = 'agendamentos-consumer';

const createOne = async (body) => {
  const response = await httpClient.POST(`${resource}`, { body });

  try {
    return response.ok
      ? {
          status: true,
        }
      : {
          status: false,
          response,
        };
  } catch (error) {
    return {
      status: false,
      response,
      error,
    };
  }
};

export default {
  createOne,
};
